<template>
    <div id="InputData">
        <input id="data"
               type="text"
               ref="dataTarefa"
               :value="value"
               @input="updateDate($event.target.value)">
        <label>{{ label }}</label>
    </div>
</template>

<script>

    export default {
        data: () => ({
            label: "Data",
        }),
        props: ['value'],
        methods: {
            updateDate(text) {
                this.$emit('input', text)
            }
        },
        mounted() {
            $(this.$refs.dataTarefa).pickadate({
                selectMonths: true, // Creates a dropdown to control month
                selectYears: 15, // Creates a dropdown of 15 years to control year,
                today: 'Hoje',
                clear: 'Limpar',
                close: 'Ok',
                closeOnSelect: false, // Close upon selecting a date,
                container: 'body', // ex. 'body' will append picker to body
            });
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/lead/form/InputData.vue